<template>
  <div class="header" :class="{'header__candidate' : candidatePage, 'header__single': singleCandidate, 'header__auth': hasAuth}">

    <div class="header__top_container">
      <div class="header__logo">
        <svg v-if="!logo" width="120" height="45" viewBox="0 0 120 45" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M26.6907 35.1261C38.1176 30.7904 45.2927 21.577 42.7516 14.6161C46.4221 24.6425 42.6021 35.685 34.1481 41.3249C30.5107 40.2579 27.8035 38.1408 26.6907 35.1261Z" fill="url(#paint0_linear)"/><path d="M26.6907 35.1261C38.1176 30.7904 45.2927 21.577 42.7515 14.6161C39.9446 15.6662 37.2706 17.0889 34.8291 18.8502C36.6893 25.6079 33.1516 32.6873 26.6907 35.1261Z" fill="url(#paint1_linear)"/><path d="M34.4637 17.7498C30.245 6.13142 21.2097 -1.1851 14.3336 1.44004C23.9834 -2.25209 34.8623 1.3723 40.526 10.1453C39.4962 13.8544 37.4201 16.632 34.4637 17.7498Z" fill="url(#paint2_linear)"/><path d="M34.4637 17.7493C30.245 6.13092 21.2097 -1.1856 14.3336 1.43954C15.3966 4.30179 16.7917 7.01161 18.4859 9.5182C25.0796 7.62132 32.0886 11.178 34.4637 17.7493Z" fill="url(#paint3_linear)"/><path d="M17.4395 9.87404C6.04576 14.2436 -1.16255 23.4232 1.41185 30.4179C-2.20891 20.5609 1.34541 9.46757 9.98209 3.69226C13.6527 4.77619 16.3433 6.85937 17.4395 9.87404Z" fill="url(#paint4_linear)"/><path d="M17.4394 9.87396C6.04566 14.2436 -1.16264 23.4231 1.41175 30.4178C4.21867 29.3678 6.89272 27.9451 9.33424 26.1837C7.49064 19.4261 11.0118 12.3467 17.4394 9.87396Z" fill="url(#paint5_linear)"/><path d="M9.68302 27.2509C13.9349 38.9031 22.9702 46.2196 29.8131 43.5606C20.1467 47.2697 9.25119 43.6284 3.58752 34.8045C4.66711 31.1801 6.72662 28.3687 9.68302 27.2509Z" fill="url(#paint6_linear)"/><path d="M9.68301 27.2509C13.9349 38.9031 22.9702 46.2196 29.8131 43.5606C28.7668 40.6983 27.3716 37.9885 25.6609 35.4819C19.0671 37.3788 12.0747 33.873 9.68301 27.2509Z" fill="url(#paint7_linear)"/><path d="M23.0367 32.6197C32.155 31.6713 39.0976 26.4549 38.5827 20.8489C36.3405 21.0691 34.1315 21.5941 32.0055 22.3901C32.0886 27.6574 28.1855 32.0947 23.0367 32.6197Z" fill="url(#paint8_linear)"/><path d="M31.9558 21.5092C31.1253 12.262 25.9765 5.14869 20.4789 5.67372C20.6948 7.96013 21.2097 10.2127 21.9903 12.3805C27.1391 12.2958 31.4741 16.2759 31.9558 21.5092Z" fill="url(#paint9_linear)"/><path d="M21.1266 12.4311C11.9917 13.3287 5.04913 18.5621 5.56401 24.168C7.82283 23.9309 10.0318 23.4397 12.1578 22.6607C12.0913 17.3935 15.9778 12.9392 21.1266 12.4311Z" fill="url(#paint10_linear)"/><path d="M12.191 23.491C13.0546 32.7722 18.2034 39.9024 23.6678 39.3266C23.4685 37.0571 22.9702 34.8045 22.1896 32.6706C17.0574 32.6875 12.656 28.7921 12.191 23.491Z" fill="url(#paint11_linear)"/><path d="M54.3778 25.3031H51.3716V30.4857H48.2325V14.4469H54.2616C57.982 14.4469 59.7259 15.9881 59.7259 19.7649C59.7259 22.136 58.8623 23.4401 57.4505 24.3378L59.6595 30.4687H56.2048L54.3778 25.3031ZM54.245 17.4955H51.3716V22.2546H54.2948C55.8726 22.2546 56.5038 21.2553 56.5038 19.8157C56.5038 18.2915 55.7398 17.4955 54.245 17.4955Z" fill="#58585A"/><path d="M69.5917 27.7081L69.6415 30.13C69.6415 30.13 67.0173 30.7736 64.9079 30.7736C61.4699 30.7736 60.0083 29.0291 60.0083 24.8458C60.0083 20.7133 61.719 18.6132 65.0408 18.6132C68.3626 18.6132 70.0069 20.3407 70.0069 23.8466L69.7744 26.0314H63.0643C63.081 27.3524 63.7287 27.9113 65.373 27.9113C67.2498 27.9113 69.5917 27.7081 69.5917 27.7081ZM67.0007 23.6433C67.0007 21.9836 66.4858 21.3908 65.0408 21.3908C63.5958 21.3908 63.081 22.1021 63.0643 23.6433H67.0007Z" fill="#58585A"/><path d="M79.2415 19.1045L79.1585 21.7804C79.1585 21.7804 77.3647 21.5941 76.4844 21.5941C74.292 21.5941 73.8934 22.3563 73.8934 24.5749C73.8934 27.0646 74.3252 27.8098 76.5176 27.8098C77.3813 27.8098 79.1585 27.6235 79.1585 27.6235L79.2415 30.2994C79.2415 30.2994 76.8 30.7906 75.5211 30.7906C72.1162 30.7906 70.7875 28.9614 70.7875 24.5919C70.7875 20.4763 72.1993 18.6472 75.6041 18.6472C76.9162 18.6133 79.2415 19.1045 79.2415 19.1045Z" fill="#58585A"/><path d="M80.5038 14.4639H83.045L88.0111 28.5719L93.0104 14.4639H95.535V30.672H94.1398V16.0898H93.8408L88.8249 30.147H87.1806L82.2145 16.0898H81.8823V30.689H80.4872V14.4639H80.5038Z" fill="#58585A"/><path d="M104.936 28.6227C105.002 29.3509 105.666 29.5711 106.414 29.6727L106.347 30.8752C105.118 30.8752 104.338 30.6381 103.773 29.9945C102.378 30.5704 100.9 30.8752 99.3883 30.9091C97.4782 30.9091 96.3654 29.6727 96.3654 27.4032C96.3654 25.2693 97.3952 24.2192 99.7204 24.016L103.59 23.6264V22.5764C103.59 20.8997 102.81 20.1883 101.398 20.1883C99.737 20.1883 97.063 20.544 97.063 20.544L96.9633 19.3077C96.9633 19.3077 99.654 18.8673 101.431 18.8673C103.806 18.8673 104.919 20.0359 104.919 22.5933V28.6227H104.936ZM99.8865 25.1168C98.3585 25.2523 97.7938 26.0991 97.7938 27.3694C97.7938 28.8598 98.4581 29.6727 99.571 29.6727C101.514 29.6727 103.607 28.8767 103.607 28.8767V24.7612L99.8865 25.1168Z" fill="#58585A"/><path d="M107.028 30.6719V19.0535H108.39V19.8834C108.39 19.8834 110.35 18.8334 112.078 18.8334C115.2 18.8334 115.881 20.2899 115.881 24.6256V30.6719H114.536V24.6595C114.536 21.2722 114.17 20.1205 111.911 20.1205C110.201 20.1205 108.374 21.1029 108.374 21.1029V30.6719H107.028Z" fill="#58585A"/><path d="M115.499 14.4804H117.293V14.7175H116.529V16.7499H116.263V14.7175H115.499V14.4804Z" fill="#58585A"/><path d="M117.592 14.4804H118.073L118.788 16.3942L119.518 14.4804H120V16.7499H119.718V14.7683H119.668L118.937 16.6652H118.638L117.924 14.7683H117.874V16.7499H117.592V14.4804Z" fill="#58585A"/></g><defs><linearGradient id="paint0_linear" x1="40.5573" y1="13.9036" x2="31.9503" y2="40.7047" gradientUnits="userSpaceOnUse"><stop stop-color="#C6E9F4"/><stop offset="1" stop-color="#0AB4DC"/></linearGradient><linearGradient id="paint1_linear" x1="26.9871" y1="35.2523" x2="43.8363" y2="15.1915" gradientUnits="userSpaceOnUse"><stop stop-color="#0FB2E8"/><stop offset="1" stop-color="#0A525F"/></linearGradient><linearGradient id="paint2_linear" x1="13.3919" y1="3.19628" x2="39.7216" y2="11.8246" gradientUnits="userSpaceOnUse"><stop stop-color="#F6EB16"/><stop offset="1" stop-color="#60B346"/></linearGradient><linearGradient id="paint3_linear" x1="35.0718" y1="17.5307" x2="14.4926" y2="1.48974" gradientUnits="userSpaceOnUse"><stop stop-color="#CADB2B"/><stop offset="1" stop-color="#2A3A1A"/></linearGradient><linearGradient id="paint4_linear" x1="3.18096" y1="31.2934" x2="12.2605" y2="4.6549" gradientUnits="userSpaceOnUse"><stop stop-color="#F6EB16"/><stop offset="1" stop-color="#F15E22"/></linearGradient><linearGradient id="paint5_linear" x1="17.0742" y1="9.44897" x2="0.572691" y2="29.8066" gradientUnits="userSpaceOnUse"><stop stop-color="#F57F20"/><stop offset="1" stop-color="#BF2025"/></linearGradient><linearGradient id="paint6_linear" x1="30.4117" y1="41.3376" x2="3.94245" y2="33.1651" gradientUnits="userSpaceOnUse"><stop stop-color="#E9B9D6"/><stop offset="1" stop-color="#8F6BAE"/></linearGradient><linearGradient id="paint7_linear" x1="9.62169" y1="27.5498" x2="29.9254" y2="43.9502" gradientUnits="userSpaceOnUse"><stop stop-color="#8F6BAE"/><stop offset="1" stop-color="#30266F"/></linearGradient><linearGradient id="paint8_linear" x1="22.8866" y1="32.9496" x2="38.9399" y2="21.7114" gradientUnits="userSpaceOnUse"><stop stop-color="#C6E9F4"/><stop offset="1" stop-color="#0AB4DC"/></linearGradient><linearGradient id="paint9_linear" x1="32.3098" y1="21.2385" x2="20.4307" y2="5.50555" gradientUnits="userSpaceOnUse"><stop stop-color="#F6EB16"/><stop offset="1" stop-color="#60B346"/></linearGradient><linearGradient id="paint10_linear" x1="20.7469" y1="12.1924" x2="4.88557" y2="23.71" gradientUnits="userSpaceOnUse"><stop stop-color="#F6EB16"/><stop offset="1" stop-color="#F15E22"/></linearGradient><linearGradient id="paint11_linear" x1="11.9008" y1="23.4709" x2="23.5067" y2="39.4149" gradientUnits="userSpaceOnUse"><stop stop-color="#E9B9D6"/><stop offset="1" stop-color="#8F6BAE"/></linearGradient><clipPath id="clip0"><rect width="120" height="45" fill="white"/></clipPath></defs></svg>
        <img v-else :src="logo" alt="logo">
      </div>
      <div class="header__title">
        {{title}}
      </div>
      <div class="header__print" style="display: none">
        <button class="header__print_btn" @click="printDropdownShow = !printDropdownShow" aria-label="Print all">
          <svg class="print__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 6V2.41406C14 2.14875 13.8947 1.89469 13.7072 1.70687L12.2928 0.292812C12.1053 0.105312 11.8509 0 11.5856 0H3C2.44781 0 2 0.447812 2 1V6C0.895313 6 0 6.89531 0 8V11.5C0 11.7762 0.22375 12 0.5 12H2V15C2 15.5522 2.44781 16 3 16H13C13.5522 16 14 15.5522 14 15V12H15.5C15.7762 12 16 11.7762 16 11.5V8C16 6.89531 15.1047 6 14 6ZM12 14H4V11H12V14ZM12 7H4V2H10V3.5C10 3.77625 10.2238 4 10.5 4H12V7ZM13.5 9.25C13.0859 9.25 12.75 8.91406 12.75 8.5C12.75 8.08562 13.0859 7.75 13.5 7.75C13.9141 7.75 14.25 8.08562 14.25 8.5C14.25 8.91406 13.9141 9.25 13.5 9.25Z" fill="#1E88E5"/></svg>
          Print all
          <svg class="down__icon" v-if="candidatePageMulti" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.57737 8.32938L2.17631 5.038C1.94123 4.8105 1.94123 4.44264 2.17631 4.21757L2.74148 3.67062C2.97656 3.44313 3.35667 3.44313 3.58925 3.67062L6 6.00363L8.41075 3.67062C8.64583 3.44313 9.02595 3.44313 9.25852 3.67062L9.82369 4.21757C10.0588 4.44506 10.0588 4.81292 9.82369 5.038L6.42263 8.32938C6.19256 8.55687 5.81244 8.55687 5.57737 8.32938Z" fill="#1E88E5"/></svg>
        </button>
        <div class="header__print_dropdown" v-if="printDropdownShow && candidatePageMulti" @click="printDropdownClick">
          <div class="dropdown__item">All</div>
          <div class="dropdown__item">Mark Zuckerberg</div>
        </div>
      </div>
    </div>

    <div class="header__bottom_container">
      <div class="header__title">
        {{title}}
      </div>

<!--      <div class="header__print">-->
<!--        <button class="header__print_btn" @click="printDropdownShow = !printDropdownShow">-->
<!--          <svg class="print__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 6V2.41406C14 2.14875 13.8947 1.89469 13.7072 1.70687L12.2928 0.292812C12.1053 0.105312 11.8509 0 11.5856 0H3C2.44781 0 2 0.447812 2 1V6C0.895313 6 0 6.89531 0 8V11.5C0 11.7762 0.22375 12 0.5 12H2V15C2 15.5522 2.44781 16 3 16H13C13.5522 16 14 15.5522 14 15V12H15.5C15.7762 12 16 11.7762 16 11.5V8C16 6.89531 15.1047 6 14 6ZM12 14H4V11H12V14ZM12 7H4V2H10V3.5C10 3.77625 10.2238 4 10.5 4H12V7ZM13.5 9.25C13.0859 9.25 12.75 8.91406 12.75 8.5C12.75 8.08562 13.0859 7.75 13.5 7.75C13.9141 7.75 14.25 8.08562 14.25 8.5C14.25 8.91406 13.9141 9.25 13.5 9.25Z" fill="#1E88E5"/></svg>-->
<!--          Print all-->
<!--          <svg class="down__icon" v-if="candidatePageMulti" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.57737 8.32938L2.17631 5.038C1.94123 4.8105 1.94123 4.44264 2.17631 4.21757L2.74148 3.67062C2.97656 3.44313 3.35667 3.44313 3.58925 3.67062L6 6.00363L8.41075 3.67062C8.64583 3.44313 9.02595 3.44313 9.25852 3.67062L9.82369 4.21757C10.0588 4.44506 10.0588 4.81292 9.82369 5.038L6.42263 8.32938C6.19256 8.55687 5.81244 8.55687 5.57737 8.32938Z" fill="#1E88E5"/></svg>-->
<!--        </button>-->
<!--        <div class="header__print_dropdown" v-if="printDropdownShow && candidatePageMulti" @click="printDropdownClick">-->
<!--          <div class="dropdown__item">All</div>-->
<!--          <div class="dropdown__item">Mark Zuckerberg</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="logout__wrap" v-if="hasAuth">
        <div class="sender__name">{{receiverName}}</div>
        <a :href="getLogoutUrl" class="logout__btn">
          <svg class="logout__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M5.625 14H3C1.34375 14 0 12.6562 0 11V5C0 3.34375 1.34375 2 3 2H5.625C5.83125 2 6 2.16875 6 2.375V3.625C6 3.83125 5.83125 4 5.625 4H3C2.44688 4 2 4.44688 2 5V11C2 11.5531 2.44688 12 3 12H5.625C5.83125 12 6 12.1687 6 12.375V13.625C6 13.8313 5.83125 14 5.625 14ZM9.30937 4.52812L11.7344 6.75H5.75C5.33437 6.75 5 7.08437 5 7.5V8.5C5 8.91563 5.33437 9.25 5.75 9.25H11.7344L9.30937 11.4719C8.99375 11.7594 8.98438 12.2531 9.28438 12.5562L9.96875 13.2406C10.2594 13.5312 10.7344 13.5344 11.0281 13.2437L15.7781 8.53125C16.075 8.2375 16.075 7.75937 15.7781 7.46562L11.0312 2.75938C10.7375 2.46875 10.2656 2.46875 9.97188 2.7625L9.2875 3.44688C8.98438 3.74688 8.99687 4.24062 9.30937 4.52812Z" fill="#1E88E5"/></g><defs><clipPath id="clip0"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
          {{ t('Log out') }}
        </a>
      </div>
    </div>

  </div>
</template>


<script>
  import { mapState } from 'vuex';
  import { useI18n } from "vue-i18n";

  export default {
    props: ['singleCandidate', 'candidatePage', 'candidatePageMulti', 'logo'],
    data(){
      return{
        title: '',
        printDropdownShow: false
      }
    },
    setup(){
      const { t } = useI18n();
      return { t };
    },
    computed: {
      ...mapState([
        'initialData',
        'hasAuth',
        'key',
        'presentationId',
        'lang'
      ]),
      receiverName(){
        return this.initialData.receiver ? this.initialData.receiver.name : '';
      },
      getLogoutUrl() {
        return process.env.NODE_ENV === 'development'
            ? `https://presentation.recmanbeta.local/logout.php?key=${this.key}&presentationId=${this.presentationId}&lang=${this.lang}`
            : `logout.php?key=${this.key}&presentationId=${this.presentationId}&lang=${this.lang}`
      }
    },
    mounted(){
      this.title = this.initialData.presentation.title;
    },
    methods: {
      printDropdownClick(e){
        if(e.target.classList.contains("dropdown__item")){
          this.printDropdownShow = false;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .header{
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #E5E5EA;

    &.header__single{
      border-left: 1px solid #E5E5EA;
      border-right: 1px solid #E5E5EA;
    }

    &.header__auth.header__candidate{
      padding: 25px 20px;

      .header__bottom_container {
        .logout__wrap {

          @media (min-width: 768px) {
            bottom: 0;
          }
        }
      }
    }

    @media (min-width: 768px){
      padding: 40px 40px 0 40px;
    }
  }

  .header__top_container{
    .header__title,
    .header__print{
      display: none;
    }
  }

  .header__bottom_container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;

    @media (min-width: 768px){
      flex-direction: row;
      align-items: baseline;
    }
  }

  .header__title{
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #333;
    margin-top: 30px;
    margin-bottom: 20px;

    @media (min-width: 768px){
      font-size: 24px;
      line-height: 36px;
      margin-top: 40px;
    }
  }

  .header__print{
    position: relative;

    @media (min-width: 768px){
      position: absolute;
      right: 0;
      bottom: 27px;
    }
  }

  .logout__wrap{
    position: relative;
    display: none;

    @media (min-width: 768px){
      position: absolute;
      right: 0;
      bottom: 27px;
    }
  }

  .header__print_btn,
  .logout__btn{
    font-weight: bold;
    font-size: 13px;
    line-height: 18px;
    color: #1E88E5;
    cursor: pointer;
    padding: 0;
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    outline: none;
    margin-left: 2px;

    .print__icon,
    .logout__icon{
      margin-right: 8px;
    }

    .down__icon{
      margin-left: 8px;
    }
  }

  .header__print_dropdown{
    background: #FFF;
    border: 1px solid #D8D8D8;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border-radius: 3px;
    padding: 15px 0 19px;
    position: absolute;
    right: 0;
    top: 18px;
    z-index: 100;
  }

  .dropdown__item{
    white-space: nowrap;
    padding: 9px 24px 9px 21px;
    cursor: pointer;

    &:hover{
      background: rgba(153, 153, 153, 0.1);
    }
  }

  .header__logo{
    display: flex;

    svg{
      width: 100%;
    }

    img{
      max-height: 70px;
    }
  }

  .header.header__candidate{
    position: relative;
    padding: 20px 20px 20px 20px;

    .header__top_container{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      position: relative;


      .header__logo{
        max-width: 85px;
        display: flex;

        @media (min-width: 768px){
          position: absolute;
          left: 0;
        }

        svg{
          width: 100%;
        }

        img{
          max-height: 45px;
          @media (min-width: 768px){
            max-width: 100%;
          }
        }
      }

      .header__title{
        display: none;

        @media (min-width: 768px){
          display: block;
          margin: 0;
          padding: 0 90px;
        }
      }

      .logout__wrap{
        display: none;

        @media (min-width: 768px){
          display: block;
          margin: 0 20px 0 0;
        }
      }


      .header__print,
      .logout__wrap{
        display: flex;
        position: relative;
        right: initial;
        bottom: initial;
        height: 100%;
      }
    }

    .header__bottom_container{
      .header__print{
        display: none;
      }

      .logout__wrap{
        display: block;
        margin-top: 20px;

        @media (min-width: 768px){
          display: block;
          bottom: 9px;
        }
      }

      .header__title{
        margin-bottom: 0;

        @media (min-width: 768px){
          display: none;
        }
      }
    }
  }

  .header__bottom_container{

    .logout__wrap{
      display: block;

      @media (min-width: 768px){
        display: block;
      }
    }
  }

  .logout__wrap a{
    text-decoration: none;
  }

  .sender__name{
    font-size: 12px;
    line-height: 16px;
    color: #999;
    margin-bottom: 5px;
  }

</style>
